import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { pillars } from '@/mocks/homeData';

const accentMap: Record<string, string> = {
  mission: 'bg-primary-100 text-primary-700',
  vision: 'bg-accent-100 text-accent-700',
  values: 'bg-secondary-100 text-secondary-700',
};

export default function AboutValues() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          eyebrow="What Drives Us"
          title="Our Mission, Vision & Values"
          description="The principles that guide every formulation we develop and every relationship we build."
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {pillars.map((item, index) => (
            <Reveal key={item.id} delay={index * 120}>
              <article className="h-full rounded-lg border border-background-200 bg-background-50 p-6 md:p-7">
                <span
                  className={`w-12 h-12 flex items-center justify-center rounded-full ${
                    accentMap[item.id] || 'bg-primary-100 text-primary-700'
                  }`}
                >
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h3 className="font-heading mt-5 text-xl font-semibold text-foreground-950">{item.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{item.description}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}